// pages/Create.tsx
import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IMaterial from '../interfaces/IMaterial';
import Layout from '~/components/Layout';

export default function Create() {
  const { register, handleSubmit, control, setValue: setFormValue } = useForm<IMaterial>();
  const fields = [
    { name: 'name', type: 'string' },
    { name: 'code', type: 'string' },
    { name: 'material_group_id', type: 'selectAutoComplete', model: 'material-group', placeholder: 'Material group' },
    { name: 'measurement_unit_id', type: 'selectAutoComplete', model: 'unit-measurement', placeholder: 'Unit Measurement' },
  ];

  return (
    <Layout marginLayout={true}>
      <CrudCreate
        model={'material'}
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        messageSuccess={'Material successfully created!'}
        title={'Add material'}
        subheader={'Add material'}
        setFormValue={setFormValue}
      />
    </Layout>
  );
}